import {
  observable,
  transaction,
  map,
  computed,
  when,
  reaction,
  runInAction,
  action
} from 'mobx';
import {tools} from 'tplus-voucher';
import LoginApi from '../api/LoginApi';

const accountInfos = ['B2BMall'];
export default class SysInfo {

  static async setSysInfo(){
    const sysInfo = await LoginApi.getSysInfoForGZQ();
    accountInfos.forEach(async item=>{
      const accountInfo = await LoginApi.getAccountInfo({"code":item});
      if(accountInfo.Value){
          tools.setLocalCache(item,accountInfo.Value);
      }
    });
    tools.setLocalCache('SysInfo',sysInfo);
  }

  //设置T+下单相关的权限信息
  static async setOrderFunction(){
    try{
      let resp = await LoginApi.getOrderFunction({'appid':'1155'});
      if(resp.Funcs){
          tools.setLocalCache('orderFuncs',resp.Funcs);
      }
    }catch(err){
      tools.setLocalCache('orderFuncs','');
    }

  }

  //设置是否启用审批流
  static async setWorkFlow(){
    try{
      let resp = await LoginApi.getWorkFlow(['SA04','SA03']);
      if(resp.Value){
          tools.setLocalCache('workFlow',resp.Value);
      }
    }catch(err){
      tools.setLocalCache('workFlow','');
    }
  }

  //从缓存中恢复Channel对象
  static getSysInfo(){
    let SysInfoCache = tools.getLocalCache('SysInfo');
    if(!tools.isNull(SysInfoCache)){
      return SysInfoCache;
    }
    return undefined;
  }

  //获取T+下单相关的权限信息
  static getOrderFunction(){
    let funcs = tools.getLocalCache('orderFuncs');
    if(!tools.isNull(funcs)){
        return funcs.split(',');;
    }
    return undefined;
  }

  static getWorkFlow(){
    let workFlow = tools.getLocalCache('workFlow');
    if(!tools.isNull(workFlow)){
        return workFlow;
    }
    return undefined;
  }

}
